export default {
  loginButton: 'Login',
  onCompleted: {
    title: 'Success',
    message: 'Welcome',
    path: '/'
  },
}
